export const MONITORING_EVENT = {
  APP_OPEN: 'APP_OPEN',
  SYNC_ACCESS: 'SYNC_ACCESS',
  SYNC_SEND_START: 'SYNC_SEND_START',
  SYNC_RECV_START: 'SYNC_RECV_START',
  SYNC_ERR: 'SYNC_ERR',
  SYNC_SEND_END: 'SYNC_SEND_END',
  SYNC_RECV_END: 'SYNC_RECV_END',
  ACT_START: 'ACT_START',
  ACT_END: 'ACT_END',
  ACT_EXIT_OPEN: 'ACT_EXIT_OPEN',
  ACT_REOPEN: 'ACT_REOPEN',
  ACT_END_APPT: 'ACT_END_APPT',
  ACT_TASK_START: 'ACT_TASK_START',
  ACT_TASK_END: 'ACT_TASK_END',
  ORD_START: 'ORD_START',
  ORD_REOPEN: 'ORD_REOPEN',
  ORD_END: 'ORD_END',
  ORD_EXIT_OPEN: 'ORD_EXIT_OPEN',
  ORD_EXIT_NOSAVE: 'ORD_EXIT_NOSAVE',
  ORD_SUMMARY: 'ORD_SUMMARY',
  ORD_RETURNS: 'ORD_RETURNS',
  ORD_CAT_VIEW: 'ORD_CAT_VIEW',
  AG_WEEK: 'AG_WEEK',
  AG_DAY: 'AG_DAY',
  HOME_ACTS: 'HOME_ACTS',
  HOME_ORDS: 'HOME_ORDS',
  HOME_ORD_PDV: 'HOME_ORD_PDV',
  HOME_DEBT: 'HOME_DEBT',
  HOME_DEBT_PDV: 'HOME_DEBT_PDV',
  HOME_COLL: 'HOME_COLL',
  HOME_COLL_LIQ: 'HOME_COLL_LIQ',
  HOME_DAY_SUM: 'HOME_DAY_SUM',
  PDV_NEW_ACCESS: 'PDV_NEW_ACCESS',
  PDV_NEW_CREATE: 'PDV_NEW_CREATE',
  FLASH_SALES: 'FLASH_SALES',
  FLASH_ACTS: 'FLASH_ACTS',
  FLASH_ORDS: 'FLASH_ORDS',
  SWIPE_APPT: 'SWIPE_APPT',
  SWIPE_ORD: 'SWIPE_ORD',
  HOME_FILTER: 'HOME_FILTER',
  HOME_MAP: 'HOME_MAP',
} as const

export type MonitoringEventId = (typeof MONITORING_EVENT)[keyof typeof MONITORING_EVENT]

const MONITORING_EVENT_IDS = new Set<string>(Object.values(MONITORING_EVENT))

export const isMonitoringEventId = (value: unknown): value is MonitoringEventId =>
  typeof value === 'string' && MONITORING_EVENT_IDS.has(value)
